import { getAPIGatewayDataFromParent } from "../../handler/ParentDataHandler";

const WCSS_PROCESS_NAME = "widgetService";

/**
 * Dashboard Configuration APIs
 */
export async function deleteDashboardConfiguration(
  businessUnit,
  configurationGroupType,
  country,
  deviceType,
  page,
  viewType,
  id,
) {
  const request = {
    resourcePath: "dashboard/DeleteDashboardConfiguration",
    httpMethod: "post",
    processName: WCSS_PROCESS_NAME,
    requestBody: {
      businessUnit,
      configurationGroupType,
      country,
      deviceType,
      page,
      viewType,
      id,
    },
  };
  return getAPIGatewayDataFromParent(request);
}

export async function getDashboardConfiguration(
  businessUnit,
  configurationGroupType,
  country,
  deviceType,
  page,
  viewTypes,
  id,
) {
  const request = {
    resourcePath: "dashboard/GetDashboardConfiguration",
    httpMethod: "post",
    processName: WCSS_PROCESS_NAME,
    requestBody: {
      businessUnit,
      configurationGroupType,
      country,
      deviceType,
      page,
      viewTypes,
      id,
    },
  };
  return getAPIGatewayDataFromParent(request);
}

export async function putDashboardConfiguration(
  businessUnit,
  configurationGroupType,
  country,
  deviceType,
  page,
  viewType,
  config,
  id,
) {
  const request = {
    resourcePath: "dashboard/PutDashboardConfiguration",
    httpMethod: "post",
    processName: WCSS_PROCESS_NAME,
    requestBody: {
      businessUnit,
      configurationGroupType,
      country,
      deviceType,
      page,
      viewType,
      config,
      id,
    },
  };
  return getAPIGatewayDataFromParent(request);
}

/**
 * Widget APIs
 */
export async function getAllAvailableWidgets() {
  const request = {
    resourcePath: "widget/GetAllAvailableWidgets",
    httpMethod: "post",
    processName: WCSS_PROCESS_NAME,
    requestBody: {},
  };
  return getAPIGatewayDataFromParent(request);
}

export async function getWidgets(widgetIds) {
  const request = {
    resourcePath: "widget/GetWidgets",
    httpMethod: "post",
    processName: WCSS_PROCESS_NAME,
    requestBody: { widgetIds },
  };
  return getAPIGatewayDataFromParent(request);
}

export async function putWidget(widgetId, configuration) {
  const config = JSON.stringify(configuration);
  const request = {
    resourcePath: "widget/PutWidgetConfiguration",
    httpMethod: "post",
    processName: WCSS_PROCESS_NAME,
    requestBody: { widgetId, config },
  };
  return getAPIGatewayDataFromParent(request);
}



// WEBPACK FOOTER //
// ./src/components/mySCC/network/WCSSNetwork.js